import { render } from "./OpeningBalance.vue?vue&type=template&id=77bce731&scoped=true"
import script from "./OpeningBalance.vue?vue&type=script&lang=js"
export * from "./OpeningBalance.vue?vue&type=script&lang=js"

import "./OpeningBalance.vue?vue&type=style&index=0&id=77bce731&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77bce731"]])

export default __exports__